import moment from "moment";
import { DealerTabSection, DealerTabState } from "@/components/DealerDetail/DealerTabState";
import { useApi } from "@/hooks/useApi";
import { dealerService } from "@/services/DealerService";
import { DealerNote } from "@/types/dealer";

const formatNoteDate = (date: string) => moment(date).format("DD/MM/YYYY HH:mm");

const sortNewestFirst = (notes: DealerNote[]) =>
  [...notes].sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime());

export function NotesTab({ dealerId }: { dealerId: number }) {
  const { data, loading, error } = useApi((signal) => dealerService.getDealerNotes(dealerId, signal), [dealerId]);

  return (
    <DealerTabState data={data} loading={loading} error={error} label="notes" emptyMessage="No notes found for this dealer.">
      {(notes) => (
        <DealerTabSection title="Notes" count={notes.length}>
          <div className="overflow-x-auto">
            <table className="w-full min-w-max text-sm">
              <thead>
                <tr className="bg-muted/40 border-b text-left">
                  <th className="p-3 font-medium">Created</th>
                  <th className="p-3 font-medium">User</th>
                  <th className="p-3 font-medium">Note</th>
                  <th className="p-3 font-medium">Visibility</th>
                  <th className="p-3 font-medium">Type</th>
                </tr>
              </thead>
              <tbody>
                {sortNewestFirst(notes).map((note) => (
                  <tr key={note.noteId} className="border-b last:border-b-0">
                    <td className="p-3">{formatNoteDate(note.createdOn)}</td>
                    <td className="p-3">{note.username?.trim() || "-"}</td>
                    <td className="p-3 min-w-80 max-w-2xl whitespace-pre-wrap break-words">{note.body?.trim() || "-"}</td>
                    <td className="p-3">{note.isPublic ? "Public" : "Private"}</td>
                    <td className="p-3">{note.isSystemGenerated ? "System" : "Manual"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DealerTabSection>
      )}
    </DealerTabState>
  );
}
